export const WORD_STATUS = {
  CHANGED: "CHANGED",
  TRANSLATED: "TRANSLATED",
  UNTRANSLATED: "UNTRANSLATED",
} as const;

export type WordStatus = (typeof WORD_STATUS)[keyof typeof WORD_STATUS];

export interface EditorWord {
  key: string;
  value: string;
  status: WordStatus;
  label?: string;
  selected: boolean;
  deleted: boolean;
}

export interface WordsListItemData {
  words: EditorWord[];
  onClickItem: (word: EditorWord) => void;
  onClickDelete: (word: EditorWord) => void;
  onClickRestore: (word: EditorWord) => void;
}
